import { useEffect, useState } from "react";

// Reads the active tenant's brand color (set as the --primary CSS var by Layout)
// and derives a cohesive chart palette so analytics inherit the white-label brand.
function readBrand() {
  if (typeof window === "undefined") return { h: 244, s: 76 };
  const v = getComputedStyle(document.documentElement).getPropertyValue("--primary").trim();
  const m = v.match(/([\d.]+)\s+([\d.]+)%\s+([\d.]+)%/);
  return m ? { h: +m[1], s: +m[2] } : { h: 244, s: 76 };
}

export function useBrandPalette() {
  const [b, setB] = useState(readBrand);
  useEffect(() => {
    const update = () => setB(readBrand());
    window.addEventListener("vc-brand-updated", update);
    const t = setTimeout(update, 250);
    return () => {
      window.removeEventListener("vc-brand-updated", update);
      clearTimeout(t);
    };
  }, []);
  const hsl = (l) => `hsl(${b.h} ${b.s}% ${l}%)`;
  return {
    primary: hsl(30),
    dark: hsl(22),
    palette: [24, 34, 44, 55, 67].map(hsl),
    grid: "#eef2f6",
  };
}
